module.exports = __webpack_public_path__ + "img/245642_3D8168_3D6858_417364-256px.71a1a114.png";